var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box",style:(("background-color: " + _vm.background + "; max-width: " + _vm.maxWidth + "; border-color: " + _vm.borderColor + "; padding: " + _vm.padding))},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }